import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";
import BookingVoucherPrintButton from "./BookingVoucherPrintButton";
import EditDriverAssignmentsModal from "./EditDriverAssignmentsModal";

const renderValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

const getIdValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value?._id || value?.id || "";
};

const DriverAssignmentsTable = ({ vehicles = [], assignmentsByVehicleId = {}, booking = {} }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const canEditAssignments = booking?.status === "confirmed";

  return (
    <div className="card">
      <div className="card-header border-0 pb-0 d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Driver Assignments</h5>
        {canEditAssignments ? (
          <div>
            <Button size="sm" variant="primary" onClick={() => setShowEditModal(true)}>
              Edit Assignments
            </Button>
          </div>
        ) : null}
      </div>
      <div className="card-body pt-3">
        {vehicles.length === 0 ? (
          <div className="text-muted">No vehicle data available.</div>
        ) : (
          <div className="table-responsive">
            <Table bordered hover size="sm" className="mb-0 align-middle">
              <thead>
                <tr>
                  <th>Vehicle</th>
                  <th>Fuel Type</th>
                  <th>Seating</th>
                  <th>Assigned Driver</th>
                  <th>Contact</th>
                  <th>License</th>
                  <th>Voucher</th>
                </tr>
              </thead>
              <tbody>
                {vehicles.map((vehicle, index) => {
                  const vehicleIdKey = getIdValue(vehicle?.vehicleId);
                  const assignments = assignmentsByVehicleId[vehicleIdKey] || [];

                  return (
                    <tr key={`${vehicleIdKey || "vehicle"}-${index}`}>
                      <td>
                        {vehicle?.snapshot?.name || vehicle?.vehicleId?.name}
                      </td>
                      <td>
                        {renderValue(vehicle?.snapshot?.fuelType || vehicle?.vehicleId?.fuelType)}
                      </td>
                      <td>
                        {renderValue(
                          vehicle?.snapshot?.specifications?.seatingCapacity ||
                            vehicle?.vehicleId?.specifications?.seatingCapacity
                        )}
                      </td>
                      <td>
                        {assignments.length > 0 ? (
                          <div className="d-grid gap-1">
                            {assignments.map((assignment, assignmentIndex) => {
                              const driver = assignment?.driverSnapshot || assignment?.driverId;
                              return (
                                <div key={`${assignment?._id || assignmentIndex}`}>
                                  {renderValue(driver?.name)}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>
                        {assignments.length > 0 ? (
                          <div className="d-grid gap-1">
                            {assignments.map((assignment, assignmentIndex) => {
                              const driver = assignment?.driverSnapshot || assignment?.driverId;
                              return (
                                <div key={`${assignment?._id || assignmentIndex}`}>
                                  {renderValue(driver?.contactNumber)}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>
                        {assignments.length > 0 ? (
                          <div className="d-grid gap-1">
                            {assignments.map((assignment, assignmentIndex) => {
                              const driver = assignment?.driverSnapshot || assignment?.driverId;
                              return (
                                <div key={`${assignment?._id || assignmentIndex}`}>
                                  {renderValue(driver?.licenseNumber || driver?.license?.number)}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>
                        {assignments.length > 0 ? (
                          <div className="d-grid gap-1">
                            {assignments.map((assignment, assignmentIndex) => (
                              <div key={`${assignment?._id || assignmentIndex}`}>
                                <BookingVoucherPrintButton booking={booking} assignment={assignment} />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </div>
      <EditDriverAssignmentsModal show={showEditModal} onClose={() => setShowEditModal(false)} booking={booking} onSuccess={() => {}} />
    </div>
  );
};

export default DriverAssignmentsTable;
